import axios from "axios";
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import storageHelper from '../../helpers/storage';
import { Types as UserTypes } from '../../sagas/users';

import If from '../../helpers/If';

function PrivateRoute({ children }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authentication = useSelector(state => state.authentication);

  const fetchUserData = React.useCallback(() => {
    dispatch({
      type: UserTypes.selfData, payload: {
        onError: () => {
          dispatch({ type: 'FAILED_USERS_AUTHENTICATION' });
          navigate('/login');
        }
      }
    });
  }, [dispatch, navigate]);

  React.useEffect(() => {
    if (authentication?.status === 'init') {
      const storage = storageHelper.get();

      if (!storage?.token) {
        dispatch({ type: 'FAILED_USERS_AUTHENTICATION' });
        navigate('/login');

        return;
      } else {
        axios.defaults.headers.common.Authorization = 'Bearer ' + storage.token;
        axios.interceptors.response.use(function (config) {
          return config;
        }, function (error) {
          if (error.response && error.response.status === 401) {
            dispatch({ type: 'FAILED_USERS_AUTHENTICATION' });
            if (window.location.href.search('/activate-user?') < 0) {
              navigate('/login');
            }

          }

          return Promise.reject(error);
        });

        fetchUserData();
      }
    }
  }, [authentication, dispatch, fetchUserData, navigate]);

  return (
    <React.Fragment>
      <If test={authentication.status === "success"}>
        {children}
      </If>
      <If test={authentication.status === "failed"}>
        <Navigate to="/login" />
      </If>
    </React.Fragment>
  )
};

PrivateRoute.propTypes = {
  children: PropTypes.any,
}

export default PrivateRoute;
